import dayjs from 'dayjs';

export function timeFormat(time: number, template = 'YYYY年MM月DD日') {
  return dayjs(new Date(time)).format(template);
}

/** 对不足两位的数字补0 */
export const timePad = (num: number) => `${num}`.padStart(2, '0');

/** 将总的秒数转换成时、分、秒 */
export function secondToDate(totalSeconds: number) {
  return {
    h: timePad(Math.floor(totalSeconds / 3600)),
    m: timePad(Math.floor((totalSeconds % 3600) / 60)),
    s: timePad(totalSeconds % 60),
  };
}
